import { Link, useNavigate } from "react-router-dom";
import "./panierClient.css";
import { useState, useEffect } from "react";
import SidBarClient from "../SideBarClient";
import PanierChrono from "../../../../components/PanierChrono";
import DefaulteImage from "../../../Admin/IMG/3.png";
import axios from "axios";
import "../../visiteur/panier_visiteur.css";
import Swal from 'sweetalert2';
import BugReportButton from '../../../../components/BugReportButton';
import '../GlobalToast.css';
import QrPaymentModal from "../../../../components/QrPaymentModal";
import OverlayLoader from "../../../../components/OverlayLoader";
import QR from "../../../../qr.png";

interface SocieteLivraison {
  id: number;
  NomSociete: string;
  AdresseSociete: string;
  Prix: string;
  Status: string;
}

interface Product {
  id: string;
  name: string;
  imageUrl: string;
  PrixNetHT?: string;
  price?: string;
  quantity: number;
  ref?: string;
  vendeur?: string;
}

export default function PanierClient() {
  const [products, setProducts] = useState<Product[]>([]);
  const navigate = useNavigate();

  const [Totale, setTotale] = useState<number>(0);
  
  // Alert/Message states
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [commandeIdForPayment, setCommandeIdForPayment] = useState('');

  // Client Details
  const ClientId = localStorage.getItem('ClientId');
  const ClientName = localStorage.getItem('ClientName');
  
  // Dynamic balance states
  const [databaseSolde, setDatabaseSolde] = useState<number | null>(null);
  const [soldeLoading, setSoldeLoading] = useState(true);

  // Form Fields for checkout
  const [nomClient, setNomClient] = useState(ClientName || '');
  const [telephone, setTelephone] = useState('');
  const [sousClient, setSousClient] = useState('');
  const [remarque, setRemarque] = useState('');

  // Delivery Options
  const [deliveryType, setDeliveryType] = useState<'societe' | 'magasin'>('societe');
  const [magasins, setMagasins] = useState<any[]>([]);
  const [selectedMagasin, setSelectedMagasin] = useState<any | null>(null);
  const [societes, setSocietes] = useState<SocieteLivraison[]>([]);
  const [selectedSociete, setSelectedSociete] = useState<SocieteLivraison | null>(null);

  const fraisSociete = selectedSociete && deliveryType === 'societe' ? (selectedSociete.Prix === '-' ? 0 : parseFloat(selectedSociete.Prix || '0')) : 0;
  const fraisLivraison = deliveryType === 'societe' ? fraisSociete : (Totale * 0.01); // 1% for magasin
  const totalAvecFrais = parseFloat((Totale + fraisLivraison).toFixed(2));

  // Payment Options: "normal" (Paiement Normal) or "solde" (Paiement par Solde)
  const [paymentMethod, setPaymentMethod] = useState<"normal" | "solde">("normal");

  // Fetch client dynamic info (real-time Solde/Credit) on mount
  useEffect(() => {
    if (!ClientId) return;
    setSoldeLoading(true);
    axios.get(`${process.env.REACT_APP_PHP_APP_URL}/client/${ClientId}/profile`)
      .then(res => {
        const c = res.data?.client;
        if (c) {
          const rawSolde = parseFloat(c.credit ?? c.Credit ?? c.Compte ?? c.Solde ?? "0");
          setDatabaseSolde(isNaN(rawSolde) ? 0 : rawSolde);
          
          if (c.NomClient) setNomClient(c.NomClient);
          if (c.Telephone) setTelephone(c.Telephone);
        } else {
          setDatabaseSolde(0);
        }
      })
      .catch(err => {
        console.error("Error fetching client profile details", err);
        setDatabaseSolde(0);
      })
      .finally(() => setSoldeLoading(false));
  }, [ClientId]);

  // Load sociétés de livraison
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_PHP_APP_URL}/admin/societe-livraison`)
      .then(({ data }) => {
        const activeSocietes = data.filter((s: SocieteLivraison) => s.Status === 'active');
        setSocietes(activeSocietes);
        if (activeSocietes.length > 0) {
          setSelectedSociete(activeSocietes[0]);
        }
      })
      .catch((err) => console.error('Erreur chargement sociétés:', err));
  }, []);

  // Load magasins
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_PHP_APP_URL}/magasins`)
      .then((res) => {
        const rawList = res.data;
        const filteredList = (Array.isArray(rawList) ? rawList : []).filter((m: any) => m.ReceptionClois == 1 || m.ReceptionClois === '1' || m.ReceptionClois === true || m.ReceptionClois === 'reception');
        setMagasins(filteredList);
        if (filteredList.length > 0) {
          setSelectedMagasin(filteredList[0]);
        }
      })
      .catch((err) => console.error('Erreur chargement magasins:', err));
  }, []);

  // Load products on mount
  useEffect(() => {
    const storedProducts = localStorage.getItem('productsClient');
    if (storedProducts) {
      try {
        const parsed = JSON.parse(storedProducts);
        setProducts(Array.isArray(parsed) ? parsed : []);
      } catch (error) {
        console.error('Error parsing products from local storage', error);
        setProducts([]);
      }
    }
  }, []);

  // Update item quantities
  const updateQuantity = (id: string, delta: number) => {
    const updated = products.map(p => {
      if (p.id === id) {
        const newQty = Math.max(1, p.quantity + delta);
        return { ...p, quantity: newQty };
      }
      return p;
    });
    setProducts(updated);
    localStorage.setItem('productsClient', JSON.stringify(updated));
  };

  // Delete product
  const handleDeleteProduct = (id: string) => {
    const updated = products.filter(p => p.id !== id);
    setProducts(updated);
    localStorage.setItem('productsClient', JSON.stringify(updated));
    if (updated.length === 0) {
      localStorage.removeItem('StartDate');
      localStorage.removeItem('cartExpiration');
      window.dispatchEvent(new Event('panier-updated'));
    }
  };

  // Clear cart
  const handleVidePanier = () => {
    localStorage.removeItem('productsClient');
    localStorage.removeItem('StartDate');
    localStorage.removeItem('cartExpiration');
    window.dispatchEvent(new Event('panier-updated'));
    setProducts([]);
    setMessage('Votre panier a été vidé avec succès !');
    setTimeout(() => setMessage(''), 3000);
  };

  // Recalculate Total
  useEffect(() => {
    let total = 0;
    products.forEach(p => {
      if (!p) return;
      const priceVal = parseFloat(String(p.PrixNetHT ?? p.price ?? "0").replace(",", "."));
      total += (isNaN(priceVal) ? 0 : priceVal) * (p.quantity || 1);
    });
    setTotale(total);
  }, [products]);

  // Handle Checkout submission
  const handleSubmitCheckout = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage('');
    setMessage('');

    if (!deliveryType) return;
    if (deliveryType === 'magasin' && !selectedMagasin) {
      setErrorMessage("Veuillez sélectionner un magasin de retrait.");
      return;
    }
    if (deliveryType === 'societe' && !selectedSociete) {
      setErrorMessage("Veuillez sélectionner une société de livraison.");
      return;
    }

    if (products.length === 0) {
      setErrorMessage("Votre panier est vide.");
      return;
    }

    setLoading(true);

    try {
      // 1. If paying by Solde, validate and deduct
      if (paymentMethod === "solde") {
        const solde = databaseSolde ?? 0;
        if (solde < totalAvecFrais) {
          setErrorMessage(`❌ Solde insuffisant ! Votre solde est de ${solde.toFixed(2)} MAD, mais la commande s'élève à ${totalAvecFrais.toFixed(2)} MAD.`);
          setLoading(false);
          return;
        }

        // Deduct
        const nextSolde = solde - totalAvecFrais;
        
        // Update database table via our new secure endpoint
        await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/client/${ClientId}/update-solde`, {
          amount: nextSolde
        });

        // Update local state and localStorage
        setDatabaseSolde(nextSolde);
        localStorage.setItem("SoldeClient", nextSolde.toString());
        localStorage.setItem("SoldeMagasin", nextSolde.toString());
        window.dispatchEvent(new Event("solde-updated"));
      }

      // 2. Fetch client's assigned magasin ID & details
      const relRes = await axios.get(`${process.env.REACT_APP_PHP_APP_URL}/client/${ClientId}/magasin`);
      const assignedMagId = relRes.data?.IdMagasin ? relRes.data.IdMagasin.toString() : null;
      const assignedMagName = relRes.data?.NomMagasin ?? relRes.data?.Nom_Complet ?? `Magasin ${assignedMagId}`;

      if (!assignedMagId) {
        setErrorMessage("Erreur : Aucun magasin n'est assigné à votre compte client.");
        setLoading(false);
        return;
      }

      // 3. Assemble and Submit Order FormData
      const currentDate = new Date();
      const deliveryAddress = deliveryType === 'magasin' && selectedMagasin
        ? selectedMagasin.adresse_de_siege
        : selectedSociete
        ? selectedSociete.AdresseSociete
        : '';

      const productVendeurName = products[0]?.vendeur
        || products[0]?.id?.toString().split('_').pop()
        || assignedMagName;

      const orderData = new FormData();
      orderData.append("NomClient", nomClient);
      orderData.append("Adresse", deliveryAddress);
      orderData.append("adress", deliveryAddress);
      orderData.append("IdMagasin", assignedMagId);
      orderData.append("NomMagasin", assignedMagName || productVendeurName);
      orderData.append("IdClient", ClientId || '');
      orderData.append("SousClient", ClientId || '');
      orderData.append("TotalCommandeHT", Totale.toString());
      orderData.append("TotalHT", Totale.toString());
      orderData.append("TotalCommandeTTC", totalAvecFrais.toString());
      orderData.append("TotalTTC", totalAvecFrais.toString());
      orderData.append("Statut", "en cours..");
      orderData.append("DateCommande", currentDate.toISOString().slice(0, 19).replace('T', ' '));
      orderData.append("TypeUtilisateur", "client");
      orderData.append("Remarque", remarque);
      orderData.append("FraisLivraison", fraisLivraison.toString());
      orderData.append("ModeLivraison", deliveryType);
      orderData.append(
        "MagasinRetrait",
        deliveryType === 'magasin' && selectedMagasin
          ? `${selectedMagasin.NomMagasin}`
          : selectedSociete ? selectedSociete.NomSociete : 'Société de livraison'
      );
      orderData.append(
        "AdresseRetreit",
        deliveryType === 'magasin' && selectedMagasin
          ? `${selectedMagasin.adresse_de_siege}`
          : selectedSociete ? selectedSociete.AdresseSociete : 'a la société'
      );
      orderData.append("SocieteLivraison", deliveryType === 'societe' && selectedSociete ? selectedSociete.NomSociete : '');
      orderData.append("MethodPayment", paymentMethod === 'solde' ? "par solde" : "A la livraison");
      orderData.append("StatutPayment", paymentMethod === 'solde' ? "payé" : "non payé");

      products.forEach((item, index) => {
        if (!item) return;
        const itemPrice = parseFloat(String(item.PrixNetHT ?? item.price ?? "0").replace(",", "."));
        const rawId = item.id ? item.id.toString().split('_')[0] : '';
        const refArticle = item.ref || (item.id ? item.id.toString().split('_').slice(0, -1).join('_') || item.id.toString().split('_')[0] : '');
        const vendeur = item.vendeur || (item.id ? item.id.toString().split('_').pop() : '') || assignedMagName;
        orderData.append(`detail[${index}][IdArticle]`, rawId);
        orderData.append(`detail[${index}][refArticle]`, refArticle);
        orderData.append(`detail[${index}][vendeur]`, vendeur);
        orderData.append(`detail[${index}][NomMagasin]`, vendeur);
        orderData.append(`detail[${index}][designation]`, item.name);
        orderData.append(`detail[${index}][quantity]`, item.quantity.toString());
        orderData.append(`detail[${index}][prix]`, (isNaN(itemPrice) ? 0 : itemPrice).toString());
      });

      // 1. Post order to enregistrerCommande (SOAP API)
      const orderResponse = await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/enregistrerCommande`, orderData);
      const idBl = orderResponse.data?.IdBl || orderResponse.data?.idbl;

      // 2. Send articles to SOAP API
      if (idBl) {
        const dataTable = products.map((item) => {
          const itemPrice = parseFloat(String(item.PrixNetHT ?? item.price ?? "0").replace(",", "."));
          const rawId = item.id ? item.id.toString().split('_')[0] : '';
          const refArticle = item.ref || (item.id ? item.id.toString().split('_').slice(0, -1).join('_') || item.id.toString().split('_')[0] : '');
          const vendeur = item.vendeur || (item.id ? item.id.toString().split('_').pop() : '') || assignedMagName;
          return {
            IdArticle: rawId,
            refArticle: refArticle,
            designation: item.name,
            prix: isNaN(itemPrice) ? 0 : itemPrice,
            quantity: item.quantity,
            NomMagasin: vendeur
          };
        });

        try {
          await axios.post(
            `${process.env.REACT_APP_PHP_APP_URL}/sendArticleCommande/${idBl}`,
            { DataTable: dataTable },
            { headers: { 'Content-Type': 'application/json' } }
          );
        } catch (soapArtErr) {
          console.error("Error sending articles to SOAP:", soapArtErr);
        }
      }

      // 4. Success State
      setMessage("🎉 Félicitations ! Votre commande a été enregistrée avec succès." + (idBl ? ` (N° BL : ${idBl})` : ""));
      setOrderSuccess(true);
      
      // Re-fetch solde to ensure we have the exact amount from DB
      if (paymentMethod === "solde") {
        axios.get(`${process.env.REACT_APP_PHP_APP_URL}/client/${ClientId}/profile`)
          .then(res => {
            const c = res.data?.client;
            if (c) {
              const rawSolde = parseFloat(c.credit ?? c.Credit ?? c.Compte ?? c.Solde ?? "0");
              setDatabaseSolde(isNaN(rawSolde) ? 0 : rawSolde);
            }
          }).catch(() => {});
      }

      // Clear cart
      localStorage.removeItem('productsClient');
      localStorage.removeItem('StartDate');
      localStorage.removeItem('cartExpiration');
      window.dispatchEvent(new Event('panier-updated'));
      setProducts([]);

      // Navigate back to home or show QR payment modal
      if (paymentMethod === "normal") {
        const commandeId = idBl || orderResponse.data.IdCom || orderResponse.data.IdCommande || orderResponse.data.id || "";
        setCommandeIdForPayment(commandeId.toString());
        setShowPayment(true);
      } else {
        setTimeout(() => navigate(`/clients/${ClientId}`), 2500);
      }

    } catch (err) {
      console.error("Error creating client checkout order", err);
      setErrorMessage("Une erreur s'est produite lors de la validation. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="client-dashboard-wrapper">
      <SidBarClient />

      <main className="client-main-content">
        {/* Breadcrumb row & Actions */}
        {/* Breadcrumb row & Actions */}
        <div className="d-flex justify-content-between align-items-center mb-4 d-none d-md-flex">
          <button
            onClick={() => window.history.back()}
            className="btn btn-outline-warning d-flex align-items-center justify-content-center"
            style={{ borderRadius: '50%', width: '42px', height: '42px', padding: 0 }}
          >
            <i className="bi bi-arrow-left" style={{ fontSize: '1.2rem' }} />
          </button>

          <div className="d-flex gap-2">
            <Link
              to={`/clients/${ClientId}/historique`}
              className="btn btn-warning font-weight-bold d-flex align-items-center gap-2"
              style={{ borderRadius: '12px', fontSize: '0.82rem', fontWeight: 700 }}
            >
              <i className="bi bi-clock-history" /> Suivi de mes Commandes
            </Link>
            {products.length > 0 && (
              <button
                onClick={handleVidePanier}
                className="btn btn-outline-danger d-flex align-items-center gap-2"
                style={{ borderRadius: '12px', fontSize: '0.82rem', fontWeight: 600 }}
              >
                <i className="bi bi-trash" /> Vider
              </button>
            )}
          </div>
        </div>

        {/* Mobile Top Actions (Bug Report + Vider) */}
        <div className="d-flex justify-content-between align-items-center mb-3 d-md-none px-1">
          <BugReportButton />
          {products.length > 0 && (
            <button
              onClick={handleVidePanier}
              className="btn btn-sm btn-outline-danger d-flex align-items-center gap-2"
              style={{ borderRadius: '12px', fontSize: '0.75rem', fontWeight: 600, padding: '6px 12px' }}
            >
              <i className="bi bi-trash" /> Vider le panier
            </button>
          )}
        </div>

        {/* Panier Counter Chrono */}
        {products.length > 0 && (
          <div className="mb-4">
            <PanierChrono />
          </div>
        )}

        {/* Global Toast Container */}
        <div className="cl-toast-container">
          {message && (
            <div className="cl-toast cl-toast--success" role="alert">
              <i className="bi bi-check-circle-fill" />
              <span className="cl-toast-msg">{message}</span>
            </div>
          )}
          {errorMessage && (
            <div className="cl-toast cl-toast--error" role="alert">
              <i className="bi bi-exclamation-triangle-fill" />
              <span className="cl-toast-msg">{errorMessage}</span>
            </div>
          )}
        </div>

        {/* Main Body Columns */}
        {products.length > 0 ? (
          <div className="row g-4">
            {/* Left Column: Cart items List */}
            <div className="col-lg-7">
              <div className="client-cart-page-box mb-4">
                <div className="client-cart-header pb-2 mb-3 d-none d-md-flex justify-content-between align-items-center">
                  <span className="d-flex align-items-center gap-2">
                    <i className="bi bi-basket-fill text-warning" /> Votre Panier d'achat
                  </span>
                  <span className="badge bg-warning text-dark rounded-pill">{products.length} articles</span>
                </div>

                <div className="d-flex flex-column gap-3">
                  {products.map((item) => {
                    if (!item) return null;
                    const cleanItemPrice = parseFloat(String(item.PrixNetHT ?? item.price ?? "0").replace(",", ".")).toFixed(2);
                    return (
                      <div
                        key={item.id || Math.random().toString()}
                        className="cl-cart-item d-flex align-items-center justify-content-between p-3 bg-light rounded-4 border border-light"
                        style={{ boxShadow: 'var(--c-shadow-xs)' }}
                      >
                        <div className="d-flex align-items-center gap-3">
                          <img
                            src={item.imageUrl ? item.imageUrl : DefaulteImage}
                            alt={item.name}
                            style={{
                              width: '68px',
                              height: '68px',
                              objectFit: 'cover',
                              borderRadius: '12px',
                              background: '#fff'
                            }}
                          />
                          <div>
                            <h4 className="h6 text-dark font-weight-bold mb-1 text-truncate" style={{ maxWidth: '200px' }}>
                              {item.name}
                            </h4>
                            <div className="text-muted" style={{ fontSize: '0.8rem' }}>
                              Réf: {item.id}
                            </div>
                            <div className="text-warning font-weight-bold" style={{ fontSize: '0.84rem' }}>
                              {cleanItemPrice} MAD
                            </div>
                          </div>
                        </div>

                        <div className="cl-cart-item__actions d-flex align-items-center gap-3">
                          {/* Quantity selectors */}
                          <div className="d-flex align-items-center gap-2 bg-white px-2 py-1 rounded-pill border">
                            <button
                              onClick={() => updateQuantity(item.id, -1)}
                              className="btn btn-sm btn-light rounded-circle px-2 py-0"
                              style={{ fontSize: '0.9rem', fontWeight: 'bold' }}
                            >
                              -
                            </button>
                            <span className="font-weight-bold text-dark" style={{ minWidth: '20px', textAlign: 'center', fontSize: '0.84rem' }}>
                              {item.quantity}
                            </span>
                            <button
                              onClick={() => updateQuantity(item.id, 1)}
                              className="btn btn-sm btn-light rounded-circle px-2 py-0"
                              style={{ fontSize: '0.9rem', fontWeight: 'bold' }}
                            >
                              +
                            </button>
                          </div>

                          <div className="text-end">
                            <div className="text-dark font-weight-bold" style={{ fontSize: '0.95rem' }}>
                              {(parseFloat(cleanItemPrice) * item.quantity).toFixed(2)} MAD
                            </div>
                            <button
                              onClick={() => handleDeleteProduct(item.id)}
                              className="btn btn-link text-danger p-0 mt-1"
                              style={{ fontSize: '0.74rem', textDecoration: 'none' }}
                            >
                              Supprimer
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Right Column: Checkout Info & Payment choice */}
            <div className="col-lg-5">
              <form onSubmit={handleSubmitCheckout} className="client-cart-page-box p-4">
                <div className="client-cart-header pb-2 mb-3">
                  <span>Informations de Livraison</span>
                </div>

                <div className="d-flex flex-column gap-3 mb-4">
                  <div>
                    <label className="form-label text-muted" style={{ fontSize: '0.82rem', fontWeight: 600 }}>Nom Complet</label>
                    <input
                      type="text"
                      className="form-control rounded-3"
                      value={nomClient}
                      onChange={e => setNomClient(e.target.value)}
                      required
                      style={{ fontSize: '0.86rem' }}
                    />
                  </div>

                  <div>
                    <label className="form-label text-muted" style={{ fontSize: '0.82rem', fontWeight: 600 }}>Téléphone de contact</label>
                    <input
                      type="text"
                      className="form-control rounded-3"
                      placeholder="Ex: 06 12 34 56 78"
                      value={telephone}
                      onChange={e => setTelephone(e.target.value)}
                      style={{ fontSize: '0.86rem' }}
                    />
                  </div>

                  {/* ── Delivery picker ── */}
                  <div className="delivery-picker" style={{ margin: '0' }}>
                    <p className="delivery-picker__label">Mode de livraison</p>
                    <div className="delivery-picker__options">
                      <div
                        className={`delivery-option ${deliveryType === 'societe' ? 'delivery-option--active' : ''}`}
                        onClick={() => setDeliveryType('societe')}
                      >
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="1" y="3" width="15" height="13"/>
                          <path d="M16 8h4l3 5v3h-7z"/>
                          <circle cx="5.5" cy="18.5" r="2.5"/>
                          <circle cx="18.5" cy="18.5" r="2.5"/>
                        </svg>
                        <span>Société de livraison</span>
                      </div>

                      <div
                        className={`delivery-option ${deliveryType === 'magasin' ? 'delivery-option--active' : ''}`}
                        onClick={() => setDeliveryType('magasin')}
                      >
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
                          <polyline points="9 22 9 12 15 12 15 22"/>
                        </svg>
                        <span>Retrait en magasin</span>
                      </div>
                    </div>

                    {/* Société de livraison list */}
                    {deliveryType === 'societe' && (
                      <div className="magasin-list">
                        <p className="magasin-list__hint">Sélectionnez la société de livraison :</p>
                        {societes.length === 0 ? (
                          <div className="magasin-empty">
                            <p>Aucune société de livraison disponible</p>
                          </div>
                        ) : (
                          societes.map((soc) => (
                            <div
                              key={soc.id}
                              className={['magasin-item', selectedSociete?.id === soc.id ? 'magasin-item--selected' : ''].filter(Boolean).join(' ')}
                              onClick={() => setSelectedSociete(soc)}
                            >
                              <div className={`magasin-radio ${selectedSociete?.id === soc.id ? 'magasin-radio--checked' : ''}`} />
                              <div className="magasin-info">
                                <div className="magasin-name-nup">
                                  <i className="bi bi-truck" style={{ color: '#9aad00', marginRight: 4 }}></i>
                                  {soc.NomSociete}
                                </div>
                                <div className="magasin-addr"><i className="bi bi-geo-alt-fill"></i> {soc.AdresseSociete}</div>
                                <div className="magasin-dist">{soc.Prix === '-' || parseFloat(soc.Prix || '0') === 0 ? "- MAD" : `${parseFloat(soc.Prix).toFixed(2)} MAD`}</div>
                              </div>
                            </div>
                          ))
                        )}
                        <div className="delivery-info-banner delivery-info-banner--blue">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                          </svg>
                          Livraison à domicile — frais de livraison selon la société sélectionnée.
                        </div>
                      </div>
                    )}

                    {/* Magasin list */}
                    {deliveryType === 'magasin' && (
                      <div className="magasin-list">
                        <p className="magasin-list__hint">Sélectionnez le magasin de retrait :</p>
                        {magasins.length === 0 ? (
                          <div className="magasin-empty">
                            <p>Aucun magasin disponible</p>
                          </div>
                        ) : (
                          magasins.map((mag) => (
                            <div
                              key={mag.IdMagasin}
                              className={['magasin-item', selectedMagasin?.IdMagasin === mag.IdMagasin ? 'magasin-item--selected' : ''].filter(Boolean).join(' ')}
                              onClick={() => setSelectedMagasin(mag)}
                            >
                              <div className={`magasin-radio ${selectedMagasin?.IdMagasin === mag.IdMagasin ? 'magasin-radio--checked' : ''}`} />
                              <div className="magasin-info">
                                <div className="magasin-addr"><i className="bi bi-geo-alt-fill"></i> {mag.adresse_de_siege}</div>
                                <div className="magasin-name-nup">magasin {mag.NomMagasin}</div>
                              </div>
                            </div>
                          ))
                        )}
                        <div className="delivery-info-banner delivery-info-banner--green">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                          </svg>
                          Frais de préparation de 1% appliqués.
                        </div>
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="form-label text-muted" style={{ fontSize: '0.82rem', fontWeight: 600 }}>Remarque ou consigne</label>
                    <input
                      type="text"
                      className="form-control rounded-3"
                      placeholder="Ex: Appeler avant la livraison"
                      value={remarque}
                      onChange={e => setRemarque(e.target.value)}
                      style={{ fontSize: '0.86rem' }}
                    />
                  </div>
                </div>

                {/* Payment choice */}
                <div className="client-cart-header pb-2 mb-3">
                  <span>Méthode de Paiement</span>
                </div>

                <div className="d-flex flex-column gap-2 mb-4">
                  {/* Option 1: Normal Payment */}
                  <div
                    className={`d-flex align-items-center justify-content-between p-3 rounded-4 border cursor-pointer transition-all ${
                      paymentMethod === "normal"
                        ? "border-warning bg-light"
                        : "border-light"
                    }`}
                    onClick={() => setPaymentMethod("normal")}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <div className="bg-warning text-dark rounded-circle d-flex align-items-center justify-content-center" style={{ width: '36px', height: '36px' }}>
                        <i className="bi bi-wallet2" />
                      </div>
                      <div>
                        <div className="text-dark font-weight-bold" style={{ fontSize: '0.86rem' }}>Paiement Normal</div>
                        <div className="text-muted" style={{ fontSize: '0.76rem' }}>Payez par virement bancaire ou espèces</div>
                      </div>
                    </div>
                    <input
                      type="radio"
                      checked={paymentMethod === "normal"}
                      onChange={() => setPaymentMethod("normal")}
                    />
                  </div>

                  {paymentMethod === "normal" && (
                    <div className="p-3 mb-2 rounded-4" style={{ backgroundColor: '#F8FAFC', border: '1px solid #E2E8F0', marginTop: '-12px', borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                      <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                        <div className="d-flex align-items-center gap-3">
                          <img src={QR} alt="QR Code" style={{ width: '70px', height: '70px', borderRadius: '8px', objectFit: 'contain', background: '#fff', padding: '4px', border: '1px solid #E2E8F0' }} />
                          <div>
                            <div className="text-dark font-weight-bold" style={{ fontSize: '0.86rem' }}>Banque Populaire</div>
                            <div className="text-muted" style={{ fontSize: '0.76rem', fontFamily: 'monospace' }}>RIB: 007 780 0003102000302865 77</div>
                          </div>
                        </div>
                        <div className="text-muted" style={{ fontSize: '0.76rem', maxWidth: '200px' }}>
                          Scannez ce QR Code pour effectuer le paiement via votre application bancaire.
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Option 2: Payment by Solde */}
                  <div
                    className={`d-flex align-items-center justify-content-between p-3 rounded-4 border cursor-pointer transition-all ${
                      paymentMethod === "solde"
                        ? "border-warning bg-light"
                        : "border-light"
                    }`}
                    onClick={() => setPaymentMethod("solde")}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <div className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '36px', height: '36px' }}>
                        <i className="bi bi-cash-coin" />
                      </div>
                      <div>
                        <div className="text-dark font-weight-bold" style={{ fontSize: '0.86rem' }}>Paiement par Solde</div>
                        <div className="text-muted" style={{ fontSize: '0.76rem' }}>
                          Votre Solde dispo:{' '}
                          <strong>
                            {soldeLoading
                              ? <span className="spinner-border spinner-border-sm" role="status" />
                              : `${(databaseSolde ?? 0).toFixed(2)} MAD`}
                          </strong>
                        </div>
                      </div>
                    </div>
                    <input
                      type="radio"
                      checked={paymentMethod === "solde"}
                      onChange={() => setPaymentMethod("solde")}
                    />
                  </div>
                </div>

                {/* Dynamic Summary */}
                <div className="bg-light p-3 rounded-4 border mb-4">
                  <div className="d-flex justify-content-between mb-2 text-muted" style={{ fontSize: '0.84rem' }}>
                    <span>Sous-total:</span>
                    <span className="text-dark font-weight-bold">{Totale.toFixed(2)} MAD</span>
                  </div>
                  <div className="d-flex justify-content-between mb-2 text-muted" style={{ fontSize: '0.84rem' }}>
                    <span>{deliveryType === 'societe' && selectedSociete ? `Frais (${selectedSociete.NomSociete}):` : 'Frais de livraison (1%):'}</span>
                    <span className="text-primary font-weight-bold">{fraisLivraison.toFixed(2)} MAD</span>
                  </div>
                  <div className="d-flex justify-content-between mb-2 text-dark" style={{ fontSize: '1rem', borderTop: '1px solid #dee2e6', paddingTop: '8px' }}>
                    <span className="font-weight-bold">Total TTC:</span>
                    <span className="font-weight-bold">{totalAvecFrais.toFixed(2)} MAD</span>
                  </div>
                  <div className="d-flex justify-content-between text-muted mt-3" style={{ fontSize: '0.84rem' }}>
                    <span>Paiement sélectionné:</span>
                    <span className={`font-weight-bold ${paymentMethod === 'solde' ? 'text-success' : 'text-primary'}`}>
                      {paymentMethod === 'solde' ? 'Par Solde' : 'Normal'}
                    </span>
                  </div>
                </div>

                {/* Submit button */}
                <button
                  type="submit"
                  disabled={loading || (paymentMethod === "solde" && (databaseSolde ?? 0) < totalAvecFrais)}
                  className="client-checkout-btn w-100 py-3 d-flex align-items-center justify-content-center gap-2"
                  style={{ border: 'none', borderRadius: '12px', fontWeight: 700 }}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Validation en cours...
                    </>
                  ) : (paymentMethod === "solde" && (databaseSolde ?? 0) < totalAvecFrais) ? (
                    <>
                      <i className="bi bi-x-circle-fill" /> Solde Insuffisant
                    </>
                  ) : (
                    <>
                      <i className="bi bi-check-circle-fill" /> Valider ma Commande
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        ) : (
          <div className="text-center py-5 border rounded bg-white mt-4" style={{ boxShadow: 'var(--c-shadow-xs)' }}>
            <i className="bi bi-bag-check-fill text-success" style={{ fontSize: '4.5rem' }} />
            <h4 className="mt-3 text-dark font-weight-bold">
              {orderSuccess ? "Commande Enregistrée !" : "Votre panier est vide"}
            </h4>
            <p className="text-muted px-4" style={{ maxWidth: '420px', margin: '10px auto', whiteSpace: 'pre-line' }}>
              {orderSuccess
                ? `Votre commande a été envoyée avec succès à notre équipe commerciale. Nous la traiterons dans les plus brefs délais.${paymentMethod === 'solde' ? `\n\nVotre nouveau solde est de ${(databaseSolde ?? 0).toFixed(2)} MAD.` : ''}`
                : "Parcourez notre collection globale ou celle de votre magasin assigné pour ajouter des équipements."}
            </p>
            <div className="d-flex justify-content-center gap-2 mt-4">
              <Link
                className="btn btn-warning px-4 py-2"
                to={`/clients/${ClientId}`}
                style={{ borderRadius: '12px', fontWeight: 700 }}
              >
                <i className="bi bi-house-door-fill" /> Accueil Boutique
              </Link>
              <Link
                className="btn btn-outline-dark px-4 py-2"
                to={`/clients/${ClientId}/historique`}
                style={{ borderRadius: '12px', fontWeight: 700 }}
              >
                <i className="bi bi-clock-history" /> Suivi Commandes
              </Link>
            </div>
          </div>
        )}
      </main>

      {/* ── QR Payment Modal ── */}
      {showPayment && (
        <QrPaymentModal
          commandeId={commandeIdForPayment}
          onBack={() => setShowPayment(false)}
          onClose={() => {
            setShowPayment(false);
            navigate(`/clients/${ClientId}`);
          }}
        />
      )}

      {/* ── Overlay Loader ── */}
      {loading && <OverlayLoader message="Enregistrement de la commande..." />}
    </div>
  );
}
